import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

const Brand = () => (
  <Typography
    variant="h6"
    noWrap
    component="div"
  >
    <Link href='/' color="inherit" underline="none">DogeCare</Link>
  </Typography>
);

export default Brand;
